export default {"src":"/_next/static/media/icon-favorite-hover.2d81ae7e.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};